import * as ReliefServices from "../../../../services/ReliefServices";
import showDialog from "../../../utils/ShowDialog/ShowDialog";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { show, hide } from "redux-modal";
import ReliefFormContainer from "../reliefTurnForm/reliefTurnForm.container";
import ReliefTextContainer from "../reliefTurn";
import { getAuthUserSelector } from "../../../../store/selectors/authSelector";

export const useRelief = (refresh) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const user = useSelector(getAuthUserSelector);

  const handlerClosePopup = (popupName) => {
    dispatch(hide(popupName));
  };

  const handlerCloseCheckInRelief = async (uuid, popupName) => {
    handlerClosePopup(popupName);
    await ReliefServices.editRelief({ read: true }, uuid);
    if (refresh) {
      refresh();
    }
  };

  const showCheckInRelief = async (nextTurnUuid, uuid) => {
    let reliefData;
    nextTurnUuid
      ? (reliefData = await ReliefServices.getNextReliefData(nextTurnUuid))
      : (reliefData = await ReliefServices.getReliefData(uuid));
    dispatch(
      show("ModalForm", {
        body: (
          <>
            <div className="row mb-3"></div>
            <div className="row">
              <div className="col-12">
                <ReliefTextContainer
                  reliefText={
                    reliefData?.observations ?? t("forms.relief.noLastTurnData")
                  }
                  onCancel={() =>
                    nextTurnUuid && reliefData?.uuid
                      ? handlerCloseCheckInRelief(reliefData?.uuid, "ModalForm")
                      : handlerClosePopup("ModalForm")
                  }
                ></ReliefTextContainer>
              </div>
            </div>
          </>
        ),
      }),
    );
  };

  const registerRelief = async (values, turnData, onSuccess = null, first) => {
    const finalValues = {
      ...values,
      // active: true,
      userUuidCreated: turnData.userUuid,
      turnUuid: turnData.uuid,
      userUuidModified: user.uuid,
      observations: values?.observations.trim() || " ",
    };

    const result = await ReliefServices.registerRelief(finalValues);

    if (!first) {
      if (result) {
        handlerClosePopup("ModalForm");

        if (onSuccess) {
          onSuccess();
        }

        showDialog(
          t(`forms.turnHistory.message.reliefs.titleOk`),
          t("forms.turnHistory.message.reliefs.success"),
          "success",
          false,
          t("forms.turnHistory.message.reliefs.buttonOk"),
          false,
        );
      } else {
        handlerClosePopup("ModalForm");
        showDialog(
          t(`forms.turnHistory.message.reliefs.titleError`),
          t("forms.turnHistory.message.reliefs.error"),
          "error",
          false,
          t("forms.turnHistory.message.reliefs.buttonOk"),
          false,
        );
      }
    }
  };

  const editRelief = async (uuid, values, onSuccess = null) => {
    const finalValues = {
      ...values,
      userUuidModified: user.uuid,
      observations: values?.observations.trim(),
    };

    const result = await ReliefServices.editRelief(finalValues, uuid);


    if (result) {
      handlerClosePopup("ModalForm");

      if (onSuccess) {
        onSuccess();
      }

      const okAction = () => {
        if (onSuccess) {
          onSuccess();
        }
      };

      showDialog(
        t(`forms.turnHistory.message.reliefs.titleEditOk`),
        t("forms.turnHistory.message.reliefs.successEdit"),
        "success",
        false,
        t("forms.turnHistory.message.reliefs.buttonOk"),
        false,
        okAction,
      );
    } else {
      handlerClosePopup("ModalForm");
      showDialog(
        t(`forms.turnHistory.message.reliefs.titleError`),
        t("forms.turnHistory.message.reliefs.error"),
        "error",
        false,
        t("forms.turnHistory.message.reliefs.buttonOk"),
        false,
      );
    }
  };

  const reliefObservations = ({
    turnData,
    onSuccess = null,
    edit,
    uuid,
    observations,
    active,
  }) => {
    dispatch(
      show("ModalForm", {
        body: (
          <>
            <div className="row mb-3"></div>
            <div className="row">
              <div className="col-12">
                <ReliefFormContainer
                  onCancel={() => handlerClosePopup("ModalForm")}
                  onSuccess={(values) =>
                    edit
                      ? editRelief(uuid, values, onSuccess, active)
                      : registerRelief(values, turnData, onSuccess)
                  }
                  observations={edit ? observations : ""}
                ></ReliefFormContainer>
              </div>
            </div>
          </>
        ),
      }),
    );
  };

  return {
    reliefObservations,
    registerRelief,
    showCheckInRelief,
  };
};
